import { OndoCode } from "../lib/OndoCode.tsx";
import { ATTRIBUTES, CODE_LEGEND, OWNERSHIP, STACKED } from "./about.constants.ts";
import type { LegendEntry } from "./about.constants.ts";

/**
 * What the colours on a work's code mean.
 *
 * DRAWN BY THE REAL RENDERER. Every swatch below is `<OndoCode>` fed a
 * `CodeFacts`, not a picture of one — so this page cannot describe a mark the
 * product does not draw, and cannot miss one it does.
 *
 * The rows the schema cannot yet answer are listed and greyed rather than
 * omitted. Somebody reading this wants to know what the system of colours IS;
 * leaving out the two that are coming would make the scheme look smaller than
 * it is, and inventing data to draw them would make it look more finished.
 */
export function CodeLegend() {
  return (
    <article className="about__section">
      <h2 className="about__title">{CODE_LEGEND.title}</h2>
      <p className="about__body">{CODE_LEGEND.lead}</p>

      <h3 className="about__sub">{CODE_LEGEND.ownershipTitle}</h3>
      <p className="about__body about__body--tight">{CODE_LEGEND.ownershipLead}</p>
      <ul className="code-legend">
        {OWNERSHIP.map((row) => (
          <LegendRow key={row.key} row={row} />
        ))}
      </ul>

      <h3 className="about__sub">{CODE_LEGEND.attributeTitle}</h3>
      <p className="about__body about__body--tight">{CODE_LEGEND.attributeLead}</p>
      <ul className="code-legend">
        {ATTRIBUTES.map((row) => (
          <LegendRow key={row.key} row={row} />
        ))}
      </ul>

      <h3 className="about__sub">{CODE_LEGEND.stackedTitle}</h3>
      <ul className="code-legend">
        {STACKED.map((row) => (
          <LegendRow key={row.key} row={row} />
        ))}
      </ul>
    </article>
  );
}

function LegendRow({ row }: { row: LegendEntry }) {
  return (
    <li className={`code-legend__row${row.facts ? "" : " code-legend__row--unissued"}`}>
      <div className="code-legend__mark">
        {row.facts ? (
          <OndoCode code={CODE_LEGEND.sample} facts={row.facts} size="record" />
        ) : null}
      </div>
      <div className="code-legend__text">
        <p className="code-legend__name">
          {row.name}
          {row.facts ? null : (
            <span className="code-legend__unissued">{CODE_LEGEND.notIssued}</span>
          )}
        </p>
        <p className="code-legend__note">{row.note}</p>
      </div>
    </li>
  );
}
